import { render, staticRenderFns } from "./ngresult.vue?vue&type=template&id=d12760b0&lang=pug&"
import script from "./ngresult.vue?vue&type=script&lang=js&"
export * from "./ngresult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports